/*
 * Offertelijst — state-module op localStorage (key: outledtl_offerte).
 *
 * Bewust LOS van de Shopify-winkelwagen: offerte-items mogen nooit in een
 * checkout terecht kunnen komen. Deze module kent geen UI; hij beheert alleen
 * de lijst en meldt elke mutatie via het document-event 'offerte:updated'.
 *
 * API: add(item), remove(variantId), setQty(variantId, qty), list(), count(), clear()
 */
(function () {
  var STORAGE_KEY = 'outledtl_offerte';
  var MAX_REGELS = 25;

  /* localStorage kan zelf al gooien (Safari private mode, uitgeschakelde
     cookies). Alle toegang loopt daarom via deze twee wrappers. */
  function rawRead() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function rawWrite(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
      return true;
    } catch (e) {
      return false;
    }
  }

  function rawClear() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* niets te doen — de lijst is dan alleen in-memory leeg */
    }
  }

  function toQty(value) {
    var n = parseInt(value, 10);
    if (isNaN(n) || n < 1) return 1;
    return n;
  }

  function toText(value) {
    return typeof value === 'string' ? value : '';
  }

  /* Alleen regels met een bruikbare variant_id overleven het inlezen. */
  function normalize(item) {
    if (!item || typeof item !== 'object') return null;
    var id = String(item.variant_id == null ? '' : item.variant_id).trim();
    if (!id) return null;
    return {
      variant_id: id,
      product_title: toText(item.product_title),
      variant_title: toText(item.variant_title),
      sku: toText(item.sku),
      image: toText(item.image),
      url: toText(item.url),
      qty: toQty(item.qty)
    };
  }

  /* Bij een parse-fout of onverwachte vorm: lijst resetten en met een lege
     lijst doorgaan. Eén corrupte key mag de PDP niet blokkeren. */
  function read() {
    var raw = rawRead();
    if (!raw) return [];

    var parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (e) {
      rawClear();
      return [];
    }

    if (!Array.isArray(parsed)) {
      rawClear();
      return [];
    }

    var items = [];
    for (var i = 0; i < parsed.length; i++) {
      var item = normalize(parsed[i]);
      if (item) items.push(item);
    }
    return items.slice(0, MAX_REGELS);
  }

  function write(items) {
    var ok;
    try {
      ok = rawWrite(JSON.stringify(items));
    } catch (e) {
      ok = false;
    }
    emit(items);
    return ok;
  }

  function emit(items) {
    var detail = { count: items.length, totalQty: totalQtyOf(items), items: items };
    document.dispatchEvent(new CustomEvent('offerte:updated', { detail: detail }));
  }

  function totalQtyOf(items) {
    var total = 0;
    for (var i = 0; i < items.length; i++) total += items[i].qty;
    return total;
  }

  function indexOfVariant(items, variantId) {
    var id = String(variantId == null ? '' : variantId).trim();
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id === id) return i;
    }
    return -1;
  }

  var OfferteLijst = {
    MAX: MAX_REGELS,

    list: function () {
      return read();
    },

    /* Aantal REGELS (niet stuks) — dat is ook waar MAX_REGELS op slaat. */
    count: function () {
      return read().length;
    },

    totalQty: function () {
      return totalQtyOf(read());
    },

    has: function (variantId) {
      return indexOfVariant(read(), variantId) !== -1;
    },

    /* Bestaat de variant al? Dan qty optellen, geen tweede regel.
       Retourneert {ok, reason, items} zodat de UI zelf de tekst kiest. */
    add: function (item) {
      var candidate = normalize(item);
      if (!candidate) return { ok: false, reason: 'invalid', items: read() };

      var items = read();
      var idx = indexOfVariant(items, candidate.variant_id);

      if (idx === -1 && items.length >= MAX_REGELS) {
        return { ok: false, reason: 'limit', items: items };
      }

      if (idx === -1) {
        items.push(candidate);
      } else {
        items[idx].qty = toQty(items[idx].qty + candidate.qty);
        /* Titel/afbeelding kunnen inmiddels gewijzigd zijn; ververs ze. */
        items[idx].product_title = candidate.product_title || items[idx].product_title;
        items[idx].variant_title = candidate.variant_title || items[idx].variant_title;
        items[idx].sku = candidate.sku || items[idx].sku;
        items[idx].image = candidate.image || items[idx].image;
        items[idx].url = candidate.url || items[idx].url;
      }

      var stored = write(items);
      return { ok: true, reason: stored ? null : 'storage', items: items, added: candidate };
    },

    remove: function (variantId) {
      var items = read();
      var idx = indexOfVariant(items, variantId);
      if (idx === -1) return { ok: false, reason: 'missing', items: items };
      items.splice(idx, 1);
      write(items);
      return { ok: true, items: items };
    },

    setQty: function (variantId, qty) {
      var items = read();
      var idx = indexOfVariant(items, variantId);
      if (idx === -1) return { ok: false, reason: 'missing', items: items };
      items[idx].qty = toQty(qty);
      write(items);
      return { ok: true, items: items };
    },

    clear: function () {
      rawClear();
      emit([]);
      return { ok: true, items: [] };
    },

    /* Platte tekstregels voor het contactformulier. */
    toLines: function () {
      var items = read();
      var lines = [];
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var parts = [(i + 1) + ') ' + item.qty + 'x'];
        if (item.sku) parts.push(item.sku);
        var titel = item.product_title;
        if (item.variant_title && item.variant_title !== 'Default Title') {
          titel += ' (' + item.variant_title + ')';
        }
        parts.push(titel);
        if (item.url) parts.push(item.url);
        lines.push(parts.join(' — '));
      }
      return lines;
    }
  };

  window.OfferteLijst = OfferteLijst;
})();
